import { CircleTick } from "assets/icons";
import { footerData } from "../helper";

function Footer() {
  return (
    <div className="footer-section flex flex-col gap-4">
      <span className="font-title-normal leading-5">
        Check these before uploading:
      </span>
      <div className="card-wrapper">
        {footerData.map((item, i) => (
          <div key={i} className="flex items-start gap-3">
            <span className="icon">
              <CircleTick />
            </span>
            <div className="">
              <span className="font-title-sm fw-700 leading-5">
                {item?.title}
              </span>
              <p className="font-title-sm fw-400 leading-5">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Footer;
